import { render, staticRenderFns } from "./stretch-breaks-a45.vue?vue&type=template&id=59b01baa&"
import script from "./stretch-breaks-a45.vue?vue&type=script&lang=js&"
export * from "./stretch-breaks-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports